import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

const ConnecteursPage = lazy(() =>
  import('./ConnecteursPage.js').then((m) => ({ default: m.ConnecteursRoute })),
);
const GuideAjoutPage = lazy(() =>
  import('./GuideAjoutPage.js').then((m) => ({ default: m.GuideAjoutRoute })),
);

/** Routes du module Connecteurs (module.json `navigation`, spec 014, vue `admin`). */
export const connecteursWeb: ModuleWeb = {
  module: 'connecteurs',
  routes: [
    { path: '/connecteurs', element: <ConnecteursPage /> },
    { path: '/connecteurs/guide-ajout', element: <GuideAjoutPage /> },
  ],
};
